import { useMemo } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { useAuth } from '@/contexts/AuthContext';
import { calculateHealthScore } from '@/lib/health-score';
import { Activity } from 'lucide-react';

export function FinancialHealthScore() {
  const { data } = useAuth();
  const score = useMemo(() => calculateHealthScore(data), [data]);

  const factors = [
    { label: 'Savings Rate', ...score.savingsRate },
    { label: 'Budget', ...score.budgetAdherence },
    { label: 'Bills', ...score.billPayment },
    { label: 'Goals', ...score.savingsProgress },
  ];

  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center gap-3 mb-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10">
            <Activity className="h-5 w-5 text-primary" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Financial Health</p>
            <div className="flex items-baseline gap-2">
              <p className={`font-display text-2xl font-bold ${score.color}`}>{score.total}</p>
              <span className="text-xs text-muted-foreground">/ 100</span>
              <span className={`text-xs font-medium ${score.color}`}>{score.label}</span>
            </div>
          </div>
        </div>

        <div className="space-y-2">
          {factors.map(f => (
            <div key={f.label}>
              <div className="flex items-center justify-between text-xs mb-0.5">
                <span className="text-muted-foreground">{f.label}</span>
                <span className="font-medium">{f.score}/{f.max}</span>
              </div>
              <Progress value={(f.score / f.max) * 100} className="h-1" />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
